import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const services = [
  {
    title: "Mobile Development",
    description:
      "Building cross-platform mobile applications with native performance — from concept to app store deployment.",
    tags: ["Flutter", "iOS", "Android"],
  },
  {
    title: "Fullstack Applications",
    description:
      "End-to-end web application development with modern frontends and robust server-side architectures.",
    tags: ["Jakarta EE", "React", "Next.js"],
  },
  {
    title: "Backend Engineering",
    description:
      "Designing scalable APIs, microservices, and data layers that power enterprise-grade systems.",
    tags: ["Springboot", "Jakarta EE", "REST", "GraphQL"],
  },
];

export default function Work() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        "[data-work-heading]",
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power3.out",
          scrollTrigger: { trigger: sectionRef.current, start: "top 80%" },
        }
      );

      gsap.utils.toArray("[data-work-item]").forEach((el, i) => {
        gsap.fromTo(
          el,
          { opacity: 0, y: 40 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power3.out",
            scrollTrigger: { trigger: el, start: "top 90%" },
          }
        );
      });
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="work"
      className="px-6 py-16 md:px-12 md:py-24 border-t border-ink/10"
    >
      <div data-work-heading className="mb-12 md:mb-16">
        <span className="font-mono text-xs tracking-widest uppercase text-ink/40 block mb-3">
          What I Do
        </span>
        <h2 className="font-serif text-4xl md:text-6xl font-bold">Services</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-12 md:gap-y-16">
        {services.map((service, i) => (
          <div key={service.title} data-work-item className="opacity-0">
            <span className="font-mono text-xs text-ink/30 block mb-3">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="font-serif text-2xl md:text-3xl font-bold mb-3">
              {service.title}
            </h3>
            <p className="font-sans text-base text-ink/60 leading-relaxed mb-4">
              {service.description}
            </p>
            <div className="flex flex-wrap gap-2">
              {service.tags.map((tag) => (
                <span
                  key={tag}
                  className="font-mono text-[10px] tracking-widest uppercase text-ink/40 border border-ink/10 px-3 py-1"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
